<template>
  <div id="js-availability" class="availability-app ui-helper-clearfix">
    <placepage/>
  </div>
</template>

<script>

import Placepage from "@/views/Placepage.vue";
import debounce from "debounce";

export default {
    name: "App",
    components: {
		    Placepage
    },
    created() {
        this.checkDemoState();
        this.setCalendarPaneCount();
        this.checkForCookieValues();
        window.addEventListener("resize", debounce(this.setCalendarPaneCount, 200));
    },
    methods: {
        setCalendarPaneCount: function() {
            let largeViewport = window.matchMedia("(min-width: 1024px)");

            if (largeViewport.matches) {
                this.$store.dispatch("setCalendarHasDoublePaneState", true);
            } else{
                this.$store.dispatch("setCalendarHasDoublePaneState", false);
            }
        },
        checkDemoState: function() {
            if (!document.body.classList.contains("single")) {
                this.$store.dispatch("setDemoStateFlag", true);
            }
        },
        checkForCookieValues: function(){
            this.$store.dispatch("initialCookieData");
        }
    }
};
</script>
